import { ActionTree } from 'vuex'
import { RootState } from '../types'
import { TodayMutations } from './mutations'
import { TodayState } from './types'
import { state } from '@/store/today/state'

export const actions: ActionTree<TodayState, RootState> = {
  //Get list of pending consultations
  async getPendingConsultations({ commit }) {
    try {
      commit(TodayMutations.SET_LOADING, true)
      setTimeout(() => {
        commit(TodayMutations.SET_LIST, state.consultationsList)
      }, 3000)
    } catch (error) {
      console.error(error)
    } finally {
      commit(TodayMutations.SET_LOADING, false)
    }
  }
}
